import { render, staticRenderFns } from "./ProductProviderCreate.vue?vue&type=template&id=42c0db18"
import script from "./ProductProviderCreate.vue?vue&type=script&lang=js"
export * from "./ProductProviderCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports